import { MIN_SEARCH_RADIUS_M } from '@/features/place/constants/place-constants';
import { type PlaceBoundingBox } from '@/features/place/types/place-types';
import calculateBboxBasedOnCenterAndRadius from '@/features/place/utils/calculate-bbox-based-on-center-and-radius';
import calculateCenterFromBbox from '@/features/place/utils/calculate-center-from-bbox';
import calculateDistance from '@/features/place/utils/calculate-distance';

export default function convertGeoBoundsWithMinimalRadius(bbox: PlaceBoundingBox): PlaceBoundingBox {
  // checking the minimum distance between the points of the box
  // increase the box to the minimum radius if necessary
  const distance = calculateDistance(bbox) * 1000; // get the distance between sw and ne points in meters

  if (distance < MIN_SEARCH_RADIUS_M * 2) {
    return calculateBboxBasedOnCenterAndRadius(calculateCenterFromBbox(bbox));
  }

  return bbox;
}
